import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl } from '@angular/forms';
import * as _lodash from 'lodash';
import { empty } from 'rxjs';
import { tap, catchError, take } from 'rxjs';
import { EmailTemplateModel } from '../../models/email-template-model';
import { EmailTemplateService } from '../../services/email-template.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'mojo-email-template-editor',
  templateUrl: './email-template-editor.component.html'
})
export class EmailTemplateEditorComponent {
 
  @Output() onCancel = new EventEmitter();
  @Output() onSaveComplete = new EventEmitter();

  emailTemplateForm: UntypedFormGroup;
  emailTemplate: EmailTemplateModel = new EmailTemplateModel();
  displayDialog: boolean;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly emailTemplateService: EmailTemplateService,
    private readonly messageService: ToastrService
  ) {
  }

  editTemplate(emailTemplate: EmailTemplateModel): void {
    this.emailTemplate = _lodash.cloneDeep(emailTemplate);

    this.buildFormFromTemplate();

    this.displayDialog = true;
  }

  factoryReset(ignored: Event): void {
    this.emailTemplateService.factoryReset(this.emailTemplate);
    this.buildFormFromTemplate(); 
  }

  buildFormFromTemplate() {
    this.emailTemplateForm = this.formBuilder.group({
      subject: [this.emailTemplate.subject],
      template: [this.emailTemplate.template],
    });
  }

  cancel(ignored: Event): void {
    this.displayDialog = false;
    this.onCancel.emit();
  }

  save(ignored: Event): void {
    this.emailTemplate.subject = this.emailTemplateForm.get('subject').value;
    this.emailTemplate.template = this.emailTemplateForm.get('template').value;
    this.emailTemplateService.saveCustomTemplate(this.emailTemplate).pipe(
      take(1),
      tap(() => {
        this.messageService.success('Email Template Saved', 'Save Successful');
        this.displayDialog = false;
      }),
      catchError(() => {
        this.messageService.error('Email Template Saved', 'Save Error');
        return empty();
      }))
      .subscribe();  
  }

  copyBodyToClipboard(ignored: Event): void {

    const text = this.emailTemplateForm.get('template').value;
    let textarea: HTMLTextAreaElement;
    try {

      textarea = document.createElement("textarea");
      textarea.style.height = '0px';
      textarea.style.left = '-1000px';
      textarea.style.opacity = '0';
      textarea.style.position = 'fixed';
      textarea.style.top = '-1000px';
      textarea.style.width = '0px';
      document.body.appendChild(textarea);

      textarea.value = text;
      textarea.select();

      document.execCommand('copy');

    } finally {

      // Cleanup - remove the Textarea from the DOM if it was injected.
      if (textarea && textarea.parentNode) {
        textarea.parentNode.removeChild(textarea);
      }

    }

  }

}
